module.exports = __webpack_public_path__ + "static/img/band-1.c188e467.png";